import styled, { css } from 'styled-components';
import { ReactComponent as FileIcon } from '~/assets/icons/download-icon.svg';
import { ReactComponent as CheckIcon } from '~/assets/icons/check-icon.svg';
import BoxFile from '../BoxFile';
import CustomButton from '~/components/layout/CustomButton';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  padding-bottom: 12px;
  margin-top: 12px;

  /* max-width: 60%;
  justify-content: space-between; */
`;

export const BoxFileOs = styled(BoxFile)``;

export const IconDownload = styled(FileIcon)`
  width: 16px;
  height: 20px;
`;

export const IconCheck = styled(CheckIcon)`
  width: 16px;
  height: 20px;
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 8px 18px;

  ${({isMobile}) =>
    isMobile && css`
      width: 50%;
    `
  }
`;

export const ContentTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 19px;
  color: #0B29FB;
`;

export const ContentDescription = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #828282;

  ${({ maxWidth }) => maxWidth && css `
      overflow: hidden;
      width: ${maxWidth};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  `}
`;

export const WrapContentFile = styled.div`
  display: flex;
  align-items: center;
`

export const FileText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #828282;
`

export const FileOsNumber = styled(FileText)`
  font-weight: 700;
  color: #0B29FB;
`

export const LinesWrap = styled.div`
  margin-left: 20px;
`;

export const FirstLine = styled.div``;

export const SecondLine = styled.div``;

export const WrapButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  @media (max-width: 800px) {
    margin-left: unset;
  }
`

export const ButtonDownload = styled(CustomButton)`
  max-width: 170px;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    max-width: 150px;
    max-height: 35px;
    font-size: 13px;
  }
`;

export const ButtonEmail = styled(ButtonDownload)`
  margin-left: 16px;

  @media (max-width: 600px) {
    margin-left: 8px;
  }
`;

export const WrapButtonsAndFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;

  @media(max-width: 1350px) {
    width: 80%
  }

  @media(max-width: 1200px) {
    width: 90%
  }

  @media(max-width: 850px) {
    width: 100%
  }

  @media(max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;

    ${WrapButtons} {
      margin-top: 20px;
    }
  }
`;

export const ContainerStatusDownload = styled.div`
    display: flex;
    align-items: center;
    width: 70%;

    ${({isMobile}) =>
      isMobile && css `
        width: 100%;
      `
    }
`;

export const ContentStatusDownload = styled.div`
  width: 100%;
  margin-left: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const PercentNumberAndStatusWrap = styled.div`
  width: 100%;
`;

export const PercentDownloadWrap = styled.div`
  width: 100%;
  background: #EFEFEF;
  height: 10px;
  border-radius: 20px;
`;

export const PercentStatusBar = styled.div`
  width: ${({percentDownload}) => `${percentDownload}%`};
  background: #0B29FB;
  height: 10px;
  border-radius: 20px;
`;

export const TextOS = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #828282;
`;

export const TextOsNumber = styled(TextOS)`
  font-weight: 700;
`;

export const NumberPercentWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;



